export const formatCurrency = (value: number | null | undefined): string => {
    if (value === null || value === undefined) return '';
    return new Intl.NumberFormat('de-DE', {
        currency: 'EUR',
        // this was not set in the frontend
        maximumFractionDigits: 2,
        // this was not set in the frontend
        minimumFractionDigits: 2,
        style: 'currency',
    }).format(value);
};
